export default {
  namespaced: true,
  state: {
    data: {}
  },
  mutations: {
    setData (state, data) {
      state.data = data;
    },
    updateBill (state, bill) {
      Object.assign(state.data.bills.find(row => row.id === bill.id), bill);
    }
  },
  getters: {
    data: state => {
      return state.data
    },
    total: state => {
      return state.data.total
    }
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/billsList.js